import { LIST_MATCHING_API_BASE_URL_V7 } from '../config';

export const ListMatchingConsentAPIRoutes = {
  columns: () => `${LIST_MATCHING_API_BASE_URL_V7}/fetch_columns`,
  availableAttributes: () => `${LIST_MATCHING_API_BASE_URL_V7}/available_attributes`,
  mapData: () => `${LIST_MATCHING_API_BASE_URL_V7}/map_data`,
  softMatchProcess: () => `${LIST_MATCHING_API_BASE_URL_V7}/soft_match_process`,
  segmentation: () => `${LIST_MATCHING_API_BASE_URL_V7}/segmentation`,
  columnSuggestions: () => `${LIST_MATCHING_API_BASE_URL_V7}/column_suggestions`,
  preview: () => `${LIST_MATCHING_API_BASE_URL_V7}/preview`,
  reservedColumns: () => `${LIST_MATCHING_API_BASE_URL_V7}/reserved_columns`,
  publish: () => `${LIST_MATCHING_API_BASE_URL_V7}/publish`,
  download: () => `${LIST_MATCHING_API_BASE_URL_V7}/download`,
};
